// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"a4f7ee7e","651":"4a124646"}[chunkId] + ".chunk.js";
};